module.exports = __webpack_public_path__ + "static/media/Message.8b090ad8.svg";